<template>
  <wizard-panel name="qualification" :status="panels.qualification" :forceFull="forceChangeOnFull" @close="closePanel"
                :style="style">
    <div class="wizard-panel__inner" v-if="forceChangeOnFull || panels.qualification === 1">
      <div class="wizard-panel__column wizard-panel__column_main js-wizard-panel-column">
        <h2 v-html="qualification.name"></h2>

        <Tabs>
          <Tab title="Информация о ПК">
            <section class="info">

              <form @submit.prevent="updateQualification($event, 'mainInfoEditable')">
                <FormInfoHeader heading="Общая информация">
                  <div v-if="!mainInfoEditable">
                    <EditBtn v-if="!read"
                             @click.prevent="mainInfoEditable = true">
                      Редактировать
                    </EditBtn>
                  </div>
                  <div v-else>
                    <SaveBtn :disabled="!nameForQualification">
                      Сохранить
                    </SaveBtn>
                    <CancelBtn @click.stop.prevent="mainInfoEditable = false, nameForQualification = qualification.name">
                      Отменить
                    </CancelBtn>
                  </div>
                </FormInfoHeader>

                <div class="info__inner">
                  <div class="info__content">
                    <div class="info-row">

                      <div class="info-cell1" style="width: 30%; margin: 0 10px;">
                        <label for="qualification-code" class="label">Номер квалификации</label>

                        <div class="info-cell__field">
                          <div v-if="!mainInfoEditable" style="font-weight: 500; font-size: 1.6rem; color: rgb(109, 109, 109);">
                            {{qualification.code}}
                          </div>
                          <masked-input v-if="mainInfoEditable"
                                        mask="11.11111.11"
                                        id="qualification-code"
                                        name="code"
                                        placeholder="Не заполнено"
                                        class="input"
                                        :value="qualification.code"
                                        :disabled="!mainInfoEditable"/>
                        </div>
                      </div>

                      <div class="info-cell1" style="width: 30%; margin: 0 10px;">
                        <label for="qualification-level" class="label">Уровень квалификации</label>

                        <div class="info-cell__field">
                          <div v-if="!mainInfoEditable" style="font-weight: 500; font-size: 1.6rem; color: rgb(109, 109, 109);">
                            <div v-if="levelForQualification" style="font-weight: 500; font-size: 1.6rem; color: rgb(109, 109, 109);">
                              {{levelForQualification}} уровень
                            </div>
                            <div v-else style="font-weight: 500; font-size: 1.6rem; color: rgb(109, 109, 109);">
                              Не указан
                            </div>
                          </div>
                          <v-select v-if="mainInfoEditable" class="select" placeholder="Уровень квалификации" label="name" v-model="levelForQualification" :options=[1,2,3,4,5,6,7,8,9] :disabled="!mainInfoEditable"/>
                        </div>
                      </div>

                      <div class="info-cell1" style="width: 30%; margin: 0 10px;">
                        <label for="qualification-level" class="label">Подуровень квалификации</label>

                        <div class="info-cell__field">

                          <div v-if="!mainInfoEditable" style="font-weight: 500; font-size: 1.6rem; color: rgb(109, 109, 109);">
                            <div v-if="sublevelForQualification" style="font-weight: 500; font-size: 1.6rem; color: rgb(109, 109, 109);">
                              {{sublevelForQualification}} подуровень
                            </div>
                            <div v-else style="font-weight: 500; font-size: 1.6rem; color: rgb(109, 109, 109);">
                              –
                            </div>
                          </div>

                          <v-select v-if="mainInfoEditable" class="select" placeholder="Не указан" v-model="sublevelForQualification" :options=[1,2,3,4,5,6,7,8,9] />
                        </div>
                      </div>


                    </div>

                    <ul class="info-list">
                      <li class="info-list__item">
                        <span class="label info-list__label">Название проекта квалификации*</span>

                        <div class="info-list__field">
                          <textarea id="qualification-name" name="name" class="info-list__textarea"
                                    :class="{ 'is-active': mainInfoEditable, 'info-list__textarea_error': mainInfoEditable && !nameForQualification }"
                                    placeholder="Не заполнено" v-autogrow v-model="nameForQualification"
                                    :disabled="!mainInfoEditable"
                                    @input="nameForQualificationChanged = true"></textarea>
                        </div>
                      </li>
                      <li class="info-list__item">
                        <span class="label info-list__label">Область профессиональной деятельности</span>
                        <div class="info-list__field" v-if="GET_KIND_BY_ID(qualification.kind_id) && GET_AREA_BY_ID(GET_KIND_BY_ID(qualification.kind_id).area_id).name">
                          <span class="info-list__textarea">{{GET_AREA_BY_ID(GET_KIND_BY_ID(qualification.kind_id).area_id).name}}</span>
                        </div>
                        <div class="info-list__field mt-24" v-else-if="qualification.area_name">
                          <span class="info-list__textarea">{{ qualification.area_name }}</span>
                        </div>
                        <div class="info-list__field mt-24" v-else>
                          <span class="info-list__textarea">ОПД отсутствует</span>
                        </div>
                      </li>

                      <li class="info-list__item">
                        <span class="label info-list__label">Вид профессиональной деятельности (при наличии профессионального стандарта)</span>
                        <div class="info-list__field" v-if="GET_KIND_BY_ID(qualification.kind_id)">
                          <span class="info-list__input" v-html="GET_KIND_BY_ID(qualification.kind_id).name"></span>
                        </div>
                        <div class="info-list__field mt-24" v-else>
                          <span class="info-list__textarea">ВПД отсутствует</span>
                        </div>
                      </li>

                      <li class="info-list__item">
                        <span class="label info-list__label">Наименование профессионального стандарта (при наличии профессионального стандарта)</span>

                        <local-preloader v-if="standartLoader"/>

                        <div v-else class="info-list__field">
                          <span class="info-list__input" v-if="standardObj(qualification.standard_id)"
                                v-html="standardObj(qualification.standard_id).name"></span>
                          <div class="info-list__field mt-24" v-else>
                            <span class="info-list__textarea">Наименование ПС отсутствует</span>
                          </div>
                        </div>
                      </li>

                      <li class="info-list__item">
                        <span class="label info-list__label">Реквизиты профессионального стандарта (при наличии профессионального стандарта)</span>
                        <div class="info-list__field" v-if="GET_STANDARD_BY_ID(qualification.standard_id)">
                          <span class="info-list__input"
                                v-html="GET_STANDARD_BY_ID(qualification.standard_id).order_number"></span>
                        </div>
                        <div class="info-list__field mt-24" v-else>
                          <span class="info-list__textarea">–</span>
                        </div>
                      </li>

                      <li class="info-list__item">
                        <span class="label info-list__label">Квалификационное требование:</span>
                        <div class="info-list__field">
                          <textarea id="qualification-requirement" name="requirement" class="info-list__textarea"
                                    :class="{ 'is-active': mainInfoEditable, 'info-list__textarea_error': mainInfoEditable && !requirementForQualification }"
                                    placeholder="Не заполнено" v-autogrow v-model="requirementForQualification"
                                    :disabled="!mainInfoEditable"></textarea>
                        </div>
                      </li>


                      <li class="info-list__item">
                        <span class="label info-list__label">Квалификационная характеристика, связанная с видом профессиональной деятельности:</span>
                        <div class="info-list__field">
                          <textarea id="qualification-characteristic" name="characteristic" class="info-list__textarea"
                                    :class="{ 'is-active': mainInfoEditable, 'info-list__textarea_error': mainInfoEditable && !requirementForQualification }"
                                    placeholder="Не заполнено"
                                    v-autogrow
                                    v-model="qualification.qualification_characteristic"
                                    :disabled="!mainInfoEditable"></textarea>
                        </div>
                      </li>


                      <li class="info-list__item">
                        <span
                            class="label info-list__label">Реквизиты протокола Совета об одобрении квалификации:</span>

                        <el-row :gutter="12">
                          <el-col :span="8">
                            <input v-model="protocol_details.date" :disabled="!mainInfoEditable" type="date"
                                   class="input html-datepicker">
                          </el-col>

                          <el-col :span="16">
                            <validate-input v-model="protocol_details.name" placeholder="Код"
                                            :disabled="!mainInfoEditable"/>
                          </el-col>

                        </el-row>
                      </li>

                      <li class="info-list__item">
                        <span class="label info-list__label">Реквизиты приказа Национального агентства об утверждении квалификации:</span>

                        <el-row :gutter="12">
                          <el-col :span="8">
                            <input v-model="order_details.date" type="date" class="input html-datepicker"
                                   :disabled="!mainInfoEditable">
                          </el-col>

                          <el-col :span="16">
                            <validate-input v-model="order_details.name" placeholder="Код"
                                            :disabled="!mainInfoEditable"/>
                          </el-col>

                        </el-row>
                      </li>

                      <!--                      <li class="info-list__item">-->
                      <!--                        <span class="label info-list__label">Дополнительные сведения:</span>-->

                      <!--                        <transition-group name="fade">-->
                      <!--                          <div class="info-list__field" v-for="(item,index) in extraForQualification" :key="index">-->
                      <!--                          <textarea class="info-list__textarea mb-8"-->
                      <!--                                    :class="{ 'is-active': mainInfoEditable, 'info-list__textarea_error': mainInfoEditable && !item }"-->
                      <!--                                    placeholder="Не заполнено" v-autogrow v-model="extraForQualification[index]"-->
                      <!--                                    :disabled="!mainInfoEditable"></textarea>-->
                      <!--                          </div>-->
                      <!--                        </transition-group>-->

                      <!--                        <transition name="fade">-->
                      <!--                          <div class="mt-8">-->
                      <!--                            <el-button-->
                      <!--                                v-if="mainInfoEditable"-->
                      <!--                                plain-->
                      <!--                                size="mini"-->
                      <!--                                icon="el-icon-plus"-->
                      <!--                                @click.stop="extraForQualification.push('')"-->
                      <!--                            > Добавить формальное образование и обучение-->
                      <!--                            </el-button>-->
                      <!--                          </div>-->
                      <!--                        </transition>-->
                      <!--                      </li>-->
                      <!--                      <li class="info-list__item">-->
                      <!--                        <span class="label info-list__label">Дополнительные характеристики:</span>-->

                      <!--                        <transition-group name="fade">-->
                      <!--                          <div class="info-list__field mb-8" v-for="(item,index) in addCharsForQualification"-->
                      <!--                               :key="index">-->
                      <!--                          <textarea class="info-list__textarea"-->
                      <!--                                    :class="{ 'is-active': mainInfoEditable, 'info-list__textarea_error': mainInfoEditable && !item }"-->
                      <!--                                    placeholder="Не заполнено" v-autogrow v-model="addCharsForQualification[index]"-->
                      <!--                                    :disabled="!mainInfoEditable"></textarea>-->
                      <!--                          </div>-->
                      <!--                        </transition-group>-->


                      <!--                        <div class="mt-8">-->
                      <!--                          <el-button-->
                      <!--                              v-if="mainInfoEditable"-->
                      <!--                              plain-->
                      <!--                              size="mini"-->
                      <!--                              icon="el-icon-plus"-->
                      <!--                              @click.stop="addCharsForQualification.push('')"-->
                      <!--                          > Добавить характеристику-->
                      <!--                          </el-button>-->
                      <!--                        </div>-->


                      <!--                        <button type="button" v-if="mainInfoEditable" class="btn btn_action-second mb-24"-->
                      <!--                                @click.stop="addCharsForQualification.push('')">-->
                      <!--                          Добавить характеристику-->
                      <!--                          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"-->
                      <!--                               fill="currentColor" class="btn__icon">-->
                      <!--                            <path-->
                      <!--                                d="M11.25 5.25H6.75V0.75C6.75 0.551088 6.67098 0.360322 6.53033 0.21967C6.38968 0.0790178 6.19891 0 6 0C5.80109 0 5.61032 0.0790178 5.46967 0.21967C5.32902 0.360322 5.25 0.551088 5.25 0.75V5.25H0.75C0.551088 5.25 0.360322 5.32902 0.21967 5.46967C0.0790178 5.61032 0 5.80109 0 6C0 6.19891 0.0790178 6.38968 0.21967 6.53033C0.360322 6.67098 0.551088 6.75 0.75 6.75H5.25V11.25C5.25 11.4489 5.32902 11.6397 5.46967 11.7803C5.61032 11.921 5.80109 12 6 12C6.19891 12 6.38968 11.921 6.53033 11.7803C6.67098 11.6397 6.75 11.4489 6.75 11.25V6.75H11.25C11.4489 6.75 11.6397 6.67098 11.7803 6.53033C11.921 6.38968 12 6.19891 12 6C12 5.80109 11.921 5.61032 11.7803 5.46967C11.6397 5.32902 11.4489 5.25 11.25 5.25Z"></path>-->
                      <!--                          </svg>-->
                      <!--                        </button>-->
                      <!--                      </li>-->


                      <li class="data-list__item">
                        <section class="info">
                          <header class="info__head">
                            <div class="info__head-inner">
                              <div class="info__head-item">
                                <p class="info__title">Описание трудовых функций</p>
                              </div>
                              <div class="info__head-item">
                                <button v-if="!read && !workFunctionsByQualificationLoader" type="button"
                                        class="change-btn" @click.stop.prevent="elPanels.qualification = 2">
                                  Редактировать
                                  <icon-base viewBox="0 0 18 18" class="change-btn__icon">
                                    <icon-edit/>
                                  </icon-base>
                                </button>
                                <button class="change-btn" v-if="read" type="button"
                                        @click.stop.prevent="elPanels.qualification = 2">
                                  Посмотреть
                                </button>
                              </div>
                            </div>
                          </header>

                          <local-preloader class="mt-24" v-if="workFunctionsByQualificationLoader"/>

                          <template v-else>
                            <li v-if="!workFunctionsByQualification.length">
                              <div class="info-list__field mt-24">
                                <p class="info-list__textarea">Трудовые функции отсутствуют</p>
                              </div>
                            </li>

                            <div class="info__inner" v-if="workFunctionsByQualification.length">
                              <div class="info__content">
                                <accordion class="accordion accordion_second">
                                  <template #accordion-captions>
                                    <div class="accordion__captions">
                                      <div class="accordion-data-list">
                                        <div class="accordion-data-list__item">
                                          <div class="accordion-data-list__column text-center">
                                            <span class="label">Код</span>
                                          </div>
                                          <div class="accordion-data-list__column">
                                            <span class="label">Наименование</span>
                                          </div>
                                          <div class="accordion-data-list__column text-center">
                                            <span class="label">Уровень</span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </template>
                                  <accordion-item v-for="(workFunction, index) in workFunctionsByQualification" :key="index">
                                    <template #accordion-head>
                                      <div class="accordion__trigger">
                                        <div class="accordion-data-list">
                                          <div class="accordion-data-list__item">
                                            <div class="accordion-data-list__column text-center"
                                                 v-html="workFunction.code"></div>
                                            <div class="accordion-data-list__column" v-html="workFunction.name"></div>
                                            <div class="accordion-data-list__column text-center"
                                                 v-html="workFunction.level"></div>
                                          </div>
                                        </div>

                                        <button type="button" class="accordion__toggler">
                                          <icon-base viewBox="0 0 14 8">
                                            <icon-arrow-down/>
                                          </icon-base>
                                        </button>
                                      </div>
                                    </template>

                                    <div class="accordion__data">
                                      <div class="accordion-data-list">
                                        <div class="accordion-data-list__item accordion-data-list__item--clickable"
                                             v-for="(child, index) in workFunction.work_functions" :key="index"
                                             @click="openWorkFunctionFromPanel(child)">
                                          <div class="accordion-data-list__column text-center"
                                               v-html="`${ child.subcode }`"></div>
                                          <div class="accordion-data-list__column" v-html="child.name"></div>
                                          <div class="accordion-data-list__column text-center" v-html="child.level"></div>
                                        </div>
                                      </div>
                                    </div>
                                  </accordion-item>
                                </accordion>
                              </div>
                            </div>
                          </template>
                        </section>
                      </li>


                      <li class="data-list__item">
                        <section class="info">

                          <FormInfoHeader heading="Связанные с ПК наименования должностей">
                            <div v-if="!editableForms.related_jobs">
                              <EditBtn v-if="!read" @click.prevent="editableForms.related_jobs = true">
                                Редактировать
                              </EditBtn>
                            </div>
                            <div v-else>
                              <CancelBtn @click.stop.prevent="editableForms.related_jobs = false">
                                Отменить
                              </CancelBtn>
                              <SaveBtn type="submit">
                                Сохранить
                              </SaveBtn>
                            </div>

                          </FormInfoHeader>

                          <!--  <header class="info__head">-->
                          <!--    <div class="info__head-inner">-->
                          <!--      <div class="info__head-item">-->
                          <!--        <p class="info__title"></p>-->
                          <!--      </div>-->
                          <!--      <div class="info__head-item">-->
                          <!--        <button v-if="!read" type="button" @click.prevent="elDialogs.relatedJobs = true" class="change-btn">-->
                          <!--          Редактировать-->
                          <!--          <icon-base viewBox="0 0 18 18" class="change-btn__icon">-->
                          <!--            <icon-edit/>-->
                          <!--          </icon-base>-->
                          <!--        </button>-->
                          <!--      </div>-->
                          <!--    </div>-->
                          <!--  </header>-->
                          <div class="info__inner">
                            <div class="info__content">

                              <RepeatableTextField v-model:value="relatedJobs"
                                                   :is-active="editableForms.related_jobs"
                                                   add-button-text="Добавить должность" />

                              <div class="info-list__field" v-if="!relatedJobs.length">
                                <p class="info-list__textarea" style="height: 60px">Связанные с ПК должности отсутствуют</p>
                              </div>
                              <!--      <div class="related-job__item" v-if="relatedJobs.length" v-for="(job, index) in relatedJobs" :key="index">-->
                              <!--        <el-row :gutter="12">-->
                              <!--          <el-col :span="18">-->
                              <!--            <span style="font-size: 18px; font-weight: 500;">-->
                              <!--              {{ job.name }}-->
                              <!--            </span>-->
                              <!--          </el-col>-->
                              <!--          <el-col :span="6">-->
                              <!--            {{ job.code }}-->
                              <!--          </el-col>-->
                              <!--        </el-row>-->
                              <!--        <el-row :gutter="12" style="margin-top: 20px;">-->
                              <!--          <el-col :span="6">-->
                              <!--            {{ job.document }}-->
                              <!--          </el-col>-->
                              <!--          <el-col :span="6">-->
                              <!--            {{ job.document_name }}-->
                              <!--          </el-col>-->
                              <!--          <el-col :span="12">-->
                              <!--            {{ job.requisites }}-->
                              <!--          </el-col>-->
                              <!--        </el-row>-->
                              <!--      </div>-->



                            </div>
                          </div>
                        </section>
                      </li>

                      <li class="data-list__item">

                        <FormInfoHeader heading="Список цифровых документов">
                          <div>
                            <EditBtn v-if="!read" @click.prevent="elDialogs.relatedJobs = true">
                              Редактировать
                            </EditBtn>
                          </div>

                        </FormInfoHeader>
                        <div class="info__inner">
                          <div class="info__content">
                            <div v-if="this.qualification.competences.length > 0" style="max-height: 300px; overflow-y: scroll;">
                              <div class="related-job__item" v-for="(competence, index) in this.qualification.competences" :key="index">
                                <el-row :gutter="12">
                                  <el-col :span="18">
                                  <span style="font-size: 18px; font-weight: 500;">
                                    {{ competence.resource }}
                                  </span>
                                  </el-col>
                                  <el-col :span="6">
                                    {{ competence.doc_code }}
                                  </el-col>
                                </el-row>
                                <el-row :gutter="12" style="margin-top: 20px;">
                                  <el-col :span="24">
                                    {{ competence.doc_name }}
                                  </el-col>
                                </el-row>
                              </div>
                            </div>


                          </div>
                        </div>



                      </li>



                      <form @submit.prevent="updateQualification($event, 'mainInfoEditable')" style="margin-top: 6rem;">
                        <header class="info__head">
                          <div class="info__head-inner">
                            <div class="info__head-item">
                              <p class="info__title">
                                Основные пути получения квалификации
                              </p>
                            </div>
                            <div class="info__head-item" v-if="!editableForms.ways_to_get_qualification">
                              <button v-if="!read" type="button" class="change-btn"
                                      @click.prevent="editableForms.ways_to_get_qualification = true">
                                Редактировать

                                <icon-base viewBox="0 0 18 18" class="change-btn__icon">
                                  <icon-edit/>
                                </icon-base>
                              </button>
                            </div>
                            <div class="info__head-item" v-else>
                              <button type="submit" class="btn btn_success btn_small">
                                Сохранить

                                <icon-base width="16" height="16" viewBox="0 0 512 512" class="btn__icon">
                                  <icon-save/>
                                </icon-base>
                              </button>

                              <button type="button" class="btn btn_danger btn_small"
                                      @click.stop.prevent="editableForms.ways_to_get_qualification = false, nameForQualification = qualification.name">
                                Отменить
                                <icon-base width="14" height="14" viewBox="0 0 14 14" class="btn__icon">
                                  <icon-cancel/>
                                </icon-base>
                              </button>
                            </div>
                          </div>
                        </header>
                        <div class="info__inner">
                          <div class="info__content">
                            <ul class="info-list">
                              <li class="info-list__item" style="margin-bottom: 25px;">

                                <div class="info-list__field">

                                  <!--          <RepeatableTextField-->
                                  <!--              label="Неформальное образование и самообучение:"-->
                                  <!--              :is-active="editableForms.ways_to_get_qualification"-->
                                  <!--              add-button-text="Добавить неформальное образование"-->
                                  <!--              v-model:value="waysToGetQualification.self_education"/>-->


                                  <div>
                                    <span class="label info-list__label">Формальное образование и обучение:</span>
                                    <transition-group name="fade">
                                      <div class="mb-4"
                                           v-for="(formal_education, index) in waysToGetQualification.formal_education" :key="index">
                  <textarea class="info-list__textarea"
                            :class="{ 'is-active': editableForms.ways_to_get_qualification}"
                            placeholder="Не заполнено" v-autogrow
                            v-model="waysToGetQualification.formal_education[index]"
                            :disabled="!editableForms.ways_to_get_qualification"></textarea>
                                      </div>
                                    </transition-group>

                                    <transition name="fade">
                                      <el-button
                                          v-if="editableForms.ways_to_get_qualification"
                                          plain
                                          size="mini"
                                          icon="el-icon-plus"
                                          @click.prevent="addFormalEducationItem"
                                      > Добавить формальное образование и обучение
                                      </el-button>
                                    </transition>
                                  </div>



                                  <div class="mt-16">
                                    <span class="label info-list__label">Неформальное образование и самообучение:</span>
                                    <transition-group name="fade">
                                      <div class="mb-4"
                                           v-for="(self_education, index) in waysToGetQualification.self_education" :key="index">
                <textarea class="info-list__textarea"
                          :class="{ 'is-active': editableForms.ways_to_get_qualification}"
                          placeholder="Не заполнено" v-autogrow
                          v-model="waysToGetQualification.self_education[index]"
                          :disabled="!editableForms.ways_to_get_qualification"></textarea>
                                      </div>
                                    </transition-group>

                                    <transition name="fade">
                                      <el-button
                                          v-if="editableForms.ways_to_get_qualification"
                                          plain
                                          size="mini"
                                          icon="el-icon-plus"
                                          @click.prevent="addSelfEducationItem"
                                      > Добавить неформальное образование
                                      </el-button>
                                    </transition>

                                  </div>

                                  <div class="mt-16">
                                    <span class="label info-list__label">Опыт практической работы:</span>
                                    <transition-group name="fade">
                                      <div class="mb-4"
                                           v-for="(work_experience, index) in waysToGetQualification.work_experience" :key="index">
                <textarea class="info-list__textarea"
                          :class="{ 'is-active': editableForms.ways_to_get_qualification}"
                          placeholder="Не заполнено" v-autogrow
                          v-model="waysToGetQualification.work_experience[index]"
                          :disabled="!editableForms.ways_to_get_qualification"></textarea>
                                      </div>
                                    </transition-group>


                                    <transition name="fade">
                                      <el-button
                                          v-if="editableForms.ways_to_get_qualification"
                                          plain
                                          size="mini"
                                          icon="el-icon-plus"
                                          @click.prevent="addWorkExperienceItem"
                                      > Добавить опыт практической работы
                                      </el-button>
                                    </transition>
                                  </div>

                                </div>


                              </li>
                            </ul>
                          </div>
                        </div>
                      </form>


                      <form @submit.prevent="updateQualification($event, 'mainInfoEditable')">

                        <FormInfoHeader heading="Специальные условия для допуска к работе">
                          <div v-if="!read">
                            <EditBtn v-if="!editableForms.special_conditions"
                                     @click.prevent="editableForms.special_conditions = true">
                              Редактировать
                            </EditBtn>

                            <div v-else>
                              <SaveBtn>Сохранить</SaveBtn>
                              <CancelBtn @click.stop.prevent="editableForms.special_conditions = false;">
                                Отменить
                              </CancelBtn>
                            </div>
                          </div>

                        </FormInfoHeader>
                        <!--<header class="info__head">-->
                        <!--  <div class="info__head-inner">-->
                        <!--    <div class="info__head-item">-->
                        <!--      <p class="info__title">Специальные условия допуска к работе</p>-->
                        <!--    </div>-->
                        <!--    <div class="info__head-item" v-if="!editableForms.special_conditions">-->
                        <!--      <button v-if="!read" type="button" class="change-btn" @click.prevent="editableForms.special_conditions = true">-->
                        <!--        Редактировать-->

                        <!--        <icon-base viewBox="0 0 18 18" class="change-btn__icon">-->
                        <!--          <icon-edit/>-->
                        <!--        </icon-base>-->
                        <!--      </button>-->
                        <!--    </div>-->
                        <!--    <div class="info__head-item" v-else>-->
                        <!--      <button type="submit" class="btn btn_success btn_small">-->
                        <!--        Сохранить-->

                        <!--        <icon-base width="16" height="16" viewBox="0 0 512 512" class="btn__icon">-->
                        <!--          <icon-save/>-->
                        <!--        </icon-base>-->
                        <!--      </button>-->

                        <!--      <button type="button" class="btn btn_danger btn_small"-->
                        <!--              @click.stop.prevent="editableForms.special_conditions = false, nameForQualification = qualification.name">-->
                        <!--        Отменить-->
                        <!--        <icon-base width="14" height="14" viewBox="0 0 14 14" class="btn__icon">-->
                        <!--          <icon-cancel/>-->
                        <!--        </icon-base>-->
                        <!--      </button>-->
                        <!--    </div>-->
                        <!--  </div>-->
                        <!--</header>-->
                        <div class="info__inner">
                          <div class="info__content">
                            <ul class="info-list">
                              <li class="info-list__item" style="margin-bottom: 25px;">
                                <!--        <span class="label info-list__label">Особые условия для допуска к работе:</span>-->

                                <RepeatableTextField v-model:value="extraForQualification"
                                                     label="Особые условия для допуска к работе:"
                                                     add-button-text="Добавить условие допуска к работе"
                                                     :is-active="editableForms.special_conditions"
                                />

                              </li>
                            </ul>
                          </div>
                        </div>
                      </form>


                      <form @submit.prevent="updateQualification($event, 'mainInfoEditable')">
                        <header class="info__head">
                          <div class="info__head-inner">
                            <div class="info__head-item">
                              <p class="info__title">
                                Наличие специального права на работу
                              </p>
                            </div>
                            <div class="info__head-item" v-if="!editableForms.rights_to_work">
                              <button v-if="!read" type="button" class="change-btn" @click.prevent="editableForms.rights_to_work = true">
                                Редактировать
                                <icon-base viewBox="0 0 18 18" class="change-btn__icon">
                                  <icon-edit/>
                                </icon-base>
                              </button>
                            </div>
                            <div class="info__head-item" v-else>
                              <button type="submit" class="btn btn_success btn_small">
                                Сохранить
                                <icon-base width="16" height="16" viewBox="0 0 512 512" class="btn__icon">
                                  <icon-save/>
                                </icon-base>
                              </button>

                              <button type="button" class="btn btn_danger btn_small"
                                      @click.stop.prevent="editableForms.rights_to_work = false, nameForQualification = qualification.name">
                                Отменить
                                <icon-base width="14" height="14" viewBox="0 0 14 14" class="btn__icon">
                                  <icon-cancel/>
                                </icon-base>
                              </button>
                            </div>
                          </div>
                        </header>
                        <div class="info__inner">
                          <div class="info__content">
                            <ul class="info-list">
                              <li class="info-list__item" style="margin-bottom: 25px;">
                                <span class="label info-list__label">Наличие специального права на работу:</span>


                                <div class="info-list__field">
                                  <div>
                                    <transition-group name="fade">
                                      <div
                                          v-for="(special_condition, index) in rights_to_work" :key="index">
                <textarea class="info-list__textarea"
                          style="margin-bottom: 8px;"
                          :class="{ 'is-active': editableForms.rights_to_work}"
                          placeholder="Наличие специального права в соответствии с ФЗ и иными нормативными актами"
                          v-autogrow
                          v-model="rights_to_work[index]"
                          :disabled="!editableForms.rights_to_work"></textarea>
                                      </div>
                                    </transition-group>

                                    <transition name="fade">

                                      <el-button
                                          v-if="editableForms.rights_to_work"
                                          plain
                                          size="mini"
                                          icon="el-icon-plus"
                                          @click.prevent="rights_to_work.push('')"
                                      > Добавить специальное право на работу
                                      </el-button>

                                    </transition>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </form>


                      <form @submit.prevent="updateQualification($event, 'mainInfoEditable')">
                        <header class="info__head">
                          <div class="info__head-inner">
                            <div class="info__head-item">
                              <p class="info__title">
                                Перечень документов для прохождения проф. экзамена
                              </p>
                            </div>
                            <div class="info__head-item" v-if="!editableForms.docs">
                              <button v-if="!read" type="button" class="change-btn" @click.prevent="editableForms.docs = true">
                                Редактировать
                                <icon-base viewBox="0 0 18 18" class="change-btn__icon">
                                  <icon-edit/>
                                </icon-base>
                              </button>
                            </div>
                            <div class="info__head-item" v-else>
                              <button type="submit" class="btn btn_success btn_small">
                                Сохранить
                                <icon-base width="16" height="16" viewBox="0 0 512 512" class="btn__icon">
                                  <icon-save/>
                                </icon-base>
                              </button>

                              <button type="button" class="btn btn_danger btn_small"
                                      @click.stop.prevent="editableForms.docs = false, nameForQualification = qualification.name">
                                Отменить
                                <icon-base width="14" height="14" viewBox="0 0 14 14" class="btn__icon">
                                  <icon-cancel/>
                                </icon-base>
                              </button>
                            </div>
                          </div>
                        </header>
                        <div class="info__inner">
                          <div class="info__content">
                            <ul class="info-list">
                              <li class="info-list__item">
                                <span class="label info-list__label">Документы для прохождения профессионального экзамена:</span>


                                <transition-group name="fade">
                                  <div v-for="(documentSet, index) in docsForQualification" :key="index"
                                       style="">
                                    <transition-group name="fade">
                                      <div v-for="(document, docIndex) in documentSet" :key="docIndex">
                                                    <textarea class="info-list__textarea"
                                                              style="margin-bottom: 5px;"
                                                              :class="{ 'is-active': editableForms.docs, 'info-list__textarea_error': false }"
                                                              placeholder="Не заполнено"
                                                              v-model="docsForQualification[index][docIndex]"
                                                              v-autogrow
                                                              :disabled="!editableForms.docs">{{ document }}</textarea>

                                      </div>
                                    </transition-group>

                                    <el-button
                                        v-if="editableForms.docs"
                                        plain
                                        size="mini"
                                        icon="el-icon-plus"
                                        @click.prevent="docsForQualification[index].push('')"
                                    > Добавить документ
                                    </el-button>

                                    <div v-if="index !== docsForQualification.length - 1" style="width: 100%; display: flex; align-items: center; margin-bottom: 28px;">
                                      <div style="width:100%; height: 2px; background: #e2e2e2;"></div>
                                      <span style="margin: 0 15px; font-weight: 500; color: #535658;">ИЛИ</span>
                                      <div style="width:100%;height: 2px; background: #e2e2e2;"></div>
                                    </div>
                                  </div>
                                </transition-group>


                                <div class="mb-24">
                                  <transition name="fade">
                                    <el-button
                                        v-if="editableForms.docs"
                                        plain
                                        type="primary"
                                        size="medium"
                                        icon="el-icon-document-add"
                                        @click.prevent="docsForQualification.push([''])"
                                    > Добавить альтернативный список документов
                                    </el-button>
                                  </transition>
                                </div>

                              </li>
                            </ul>
                          </div>
                        </div>
                      </form>


                      <form @submit.prevent="updateQualification($event, 'mainInfoEditable')">
                        <header class="info__head">
                          <div class="info__head-inner">
                            <div class="info__head-item">
                              <p class="info__title">
                                Срок действия свидетельства о квалификации
                              </p>
                            </div>
                            <div class="info__head-item" v-if="!editableForms.validity">
                              <button v-if="!read" type="button" class="change-btn" @click.prevent="editableForms.validity = true">
                                Редактировать

                                <icon-base viewBox="0 0 18 18" class="change-btn__icon">
                                  <icon-edit/>
                                </icon-base>
                              </button>
                            </div>
                            <div class="info__head-item" v-else>
                              <button type="submit" class="btn btn_success btn_small">
                                Сохранить
                                <icon-base width="16" height="16" viewBox="0 0 512 512" class="btn__icon">
                                  <icon-save/>
                                </icon-base>
                              </button>

                              <button type="button" class="btn btn_danger btn_small"
                                      @click.stop.prevent="editableForms.validity = false, nameForQualification = qualification.name">
                                Отменить
                                <icon-base width="14" height="14" viewBox="0 0 14 14" class="btn__icon">
                                  <icon-cancel/>
                                </icon-base>
                              </button>
                            </div>
                          </div>
                        </header>
                        <div class="info__inner">
                          <div class="info__content">
                            <ul class="info-list">
                              <li class="info-list__item" style="margin-bottom: 25px;">

                                <CellInput
                                    label="Срок действия свидетельства"
                                    id="qualification-validity"
                                    name="validity"
                                    placeholder="Не заполнено"
                                    v-model="validityForQualification"
                                    :disabled="!editableForms.validity"
                                />

                                <CellInput
                                    label="Квалификация утрачивает силу"
                                    id="qualification-invalid-at"
                                    name="invalid_at"
                                    placeholder="Не заполнено"
                                    v-model="invalid_at"
                                    :disabled="!editableForms.validity"
                                />

                              </li>
                            </ul>
                          </div>
                        </div>
                      </form>


                    </ul>
                  </div>
                </div>
              </form>

            </section>
          </Tab>

          <Tab title="Скилы">
            <header class="competence__head">
              <div class="competence__head-inner">
                <div class="competence__head-item">
                  <h1 class="competence__title">Soft Skills</h1>
                </div>
              </div>
            </header>

            <local-preloader class="mt-12" v-if="softSkillsByQualificationLoader"/>

            <accordion class="mt-12" v-else>
              <div tabindex="0" class="accordion__head accordion__head_only-read" v-if="softSkills.length === 0">
                <div class="accordion__head-item">
                  <p class="accordion__title">CC отсутствуют</p>
                </div>
              </div>

              <accordion-item ref="softSkills" v-for="(item, index) in softSkills" :key="item.id">
                <template #accordion-head>
                  <div tabindex="0" class="accordion__head">
                    <div class="accordion__head-item">
                      <p class="accordion__title" v-html="item.name"></p>
                    </div>

                    <div class="accordion__head-item">
                      <icon-base viewBox="0 0 14 8" class="accordion__arrow">
                        <icon-arrow-down/>
                      </icon-base>
                    </div>
                  </div>
                </template>

                <div class="accordion__content">
                  <div class="competence">
                    <header class="competence__head">
                      <div class="competence__head-inner">
                        <div class="competence__head-item">
                          <h2 class="competence__title">Дескрипторы компетенции</h2>
                        </div>
                      </div>
                    </header>
                    <div class="competence__content">
                      <div v-html="item.competency_descriptor"></div>
                    </div>
                  </div>
                </div>
              </accordion-item>
            </accordion>

            <header class="competence__head mt-24">
              <div class="competence__head-inner">
                <div class="competence__head-item">
                  <h1 class="competence__title">Hard Skills</h1>
                </div>
              </div>
            </header>

            <local-preloader class="mt-12" v-if="hardSkillsByQualificationLoader"/>

            <ul class="entry-list mt-12" v-else>
              <div tabindex="0" class="accordion__head accordion__head_only-read"
                   v-if="hardSkillsByQualification.length === 0">
                <div class="accordion__head-item">
                  <p class="accordion__title">Hard Skills отсутствуют</p>
                </div>
              </div>

              <li class="entry-list__item" v-for="item in hardSkillsByQualification" :key="item.id">
                <div class="entry">
                  <div class="entry__inner">
                    <div class="entry__item" v-html="item.name"></div>
                  </div>
                </div>
              </li>
            </ul>
          </Tab>

          <Tab title="Взаимосвязи ПК">
            <tabs caption="Взаимосвязи" @clickOnTitle="forceFullWidth" :reset="!forceChangeOnFull">
              <tab title="Список">
                <ul class="data-list">
                  <local-preloader class="mt-24" v-if="interrelationsByQualificationLoader"/>

                  <template v-else>
                    <li v-if="Object.keys(groupInterrelations).length === 0">
                      <section class="info">
                        <header class="info__head">
                          <div class="info__head-inner">
                            <div class="info__head-item">
                              <p class="info__title">Взаимосвязи отсутствуют</p>
                            </div>
                          </div>
                        </header>
                      </section>
                    </li>

                    <li v-else class="data-list__item" v-for="(interrelation, key) in groupInterrelations" :key="key">
                      <section class="info">
                        <header class="info__head">
                          <div class="info__head-inner">
                            <div class="info__head-item">
                              <p class="info__title">{{ relationsType[key] }}</p>
                            </div>
                          </div>
                        </header>

                        <div class="info__inner">
                          <div class="info__content">
                            <el-table
                                cell-class-name="table__cell"
                                class="table table_second table_in-panel"
                                header-cell-class-name="table__title"
                                max-height="400"
                                ref="table"
                                row-key="id"
                                :data="interrelation"
                            >
                              <el-table-column
                                  align="center"
                                  label="Код ОПД"
                                  prop="qualification_to.area_code"
                                  :width="80"
                              />
                              <el-table-column
                                  align="center"
                                  label="Код ВПД"
                                  prop="qualification_to.kind_code"
                                  :width="80"
                              />
                              <el-table-column
                                  align="center"
                                  label="Код ПК"
                                  prop="qualification_to.code"
                                  :width="100"
                              />
                              <el-table-column
                                  label="Название"
                                  prop="qualification_to.name"
                                  sortable
                              />
                              <el-table-column
                                  align="center"
                                  label="Уровень"
                                  prop="qualification_to.level"
                                  :width="80"
                              />
                              <el-table-column
                                  align="center"
                                  label="Подуровень"
                                  prop="qualification_to.level"
                                  :width="100"
                              />
                              <el-table-column
                                  align="center"
                                  label="Обр. прог"
                                  :width="80"
                              >
                                <template slot-scope="scope">
                                  <button v-if="scope.row.education_programs" type="button" class="settings-btn"
                                          @click="loadQualificationPrograms(scope.row)">
                                    <icon-base viewBox="0 0 12 14" class="settings-btn__icon">
                                      <icon-book/>
                                    </icon-base>
                                  </button>
                                </template>
                              </el-table-column>
                            </el-table>
                          </div>
                        </div>
                      </section>
                    </li>
                  </template>
                </ul>
              </tab>

              <tab title="Диаграмма">
                <local-preloader class="mt-24" v-if="interrelationsByQualificationLoader"/>

                <div v-else-if="forceChangeOnFull" class="diagram">


                  <div style="position:relative;">
                    <div style="position: absolute; margin-left: 200px; margin-top: -90px;">

                      <ul class="legend-list diagram__legend-list mb-16">
                        <li class="legend-list__item">
                                            <span class="legend-list__label">
                                                Связанные

                                                <icon-base viewBox="0 0 16 16" class="legend-list__icon"><icon-arrow-right-second/></icon-base>
                                            </span>
                        </li>

                        <li class="legend-list__item">
                                            <span class="legend-list__label legend-list__label_second">
                                                Родственные

                                                <icon-base viewBox="0 0 16 16" class="legend-list__icon"><icon-arrow-right-second/></icon-base>
                                            </span>
                        </li>

                        <li class="legend-list__item ml-auto">
                          <button class="legend-list__btn" :disabled="scale === 1" @click="scaleUp">
                            <icon-base viewBox="0 0 12 12">
                              <icon-action/>
                            </icon-base>
                          </button>
                          <button class="legend-list__btn ml-12" :disabled="scale === 0.1" @click="scaleDown">
                            <icon-base viewBox="0 0 300 300">
                              <icon-remove/>
                            </icon-base>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>


                  <tree ref="tree" :tree-data="treeInterrelations" @openProgramsDialog="loadQualificationPrograms"/>
                </div>
              </tab>
            </tabs>
          </Tab>
        </Tabs>
      </div>
    </div>


    <div class="wizard-panel__inner" v-else-if="panels.qualification === 2">
      <div class="wizard-panel__column js-wizard-panel-column pb-0">
        <div class="badge wizard-panel__badge" v-html="qualification.name"></div>

        <h2>Трудовые функции</h2>

        <button type="button" class="btn btn_action-second btn_transparent" v-if="!read"
                @click="elDialogs.workFunctions = true">
          Создать или найти трудовую функцию
          <icon-base width="12" height="12" viewBox="0 0 12 12" class="btn__icon">
            <icon-action/>
          </icon-base>
        </button>

        <accordion class="accordion accordion_second">
          <template slot="accordion-captions">
            <div class="accordion__captions">
              <div class="accordion-data-list">
                <div class="accordion-data-list__item">
                  <div class="accordion-data-list__column text-center">
                    <span class="label">Код</span>
                  </div>
                  <div class="accordion-data-list__column">
                    <span class="label">Наименование</span>
                  </div>
                  <div class="accordion-data-list__column text-center">
                    <span class="label">Уровень</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <accordion-item v-for="(workFunction, index) in workFunctionsByQualification" :active="index === 0"
                          :key="workFunction.id">
            <template slot="accordion-head">
              <div class="accordion__trigger">
                <div class="accordion-data-list">
                  <div class="accordion-data-list__item">
                    <div class="accordion-data-list__column text-center" v-html="workFunction.code"></div>
                    <div class="accordion-data-list__column" v-html="workFunction.name"></div>
                    <div class="accordion-data-list__column text-center" v-html="workFunction.level"></div>
                  </div>
                </div>

                <button type="button" class="accordion__toggler">
                  <icon-base viewBox="0 0 14 8">
                    <icon-arrow-down/>
                  </icon-base>
                </button>
              </div>
            </template>

            <div class="accordion__data" v-if="workFunction.work_functions.length">
              <div class="accordion-data-list accordion-data-list_editable">
                <div
                    :class="{ 'accordion-data-list__item': true, 'is-active': item === activeWorkFunction || (!activeWorkFunction && index === 0 && count === 0 && getWorkFunctionItems(item)) }"
                    v-for="(item, count) in workFunction.work_functions" @click="getWorkFunctionItems(item)">
                  <div class="accordion-data-list__column text-center"
                       v-html="`${ workFunction.code }/${ item.subcode }`">
                  </div>
                  <div class="accordion-data-list__column" v-html="item.name">
                  </div>
                  <div class="accordion-data-list__column text-center">
                    {{ item.level }}

                    <selector-btn class="ml-auto" v-if="!read" :options="accordionWorkFunctionOptionsForBtn"
                                  portal="selectorModal" :toRight="true" :clickStop="true"
                                  :params="{ commonWorkFunctionsId: workFunction.id, commonWorkFunctionsLevel: workFunction.level, id: item.id, workFunction: item }"
                                  @clickOnItem="callback"></selector-btn>
                  </div>
                </div>
              </div>
            </div>
          </accordion-item>
        </accordion>
      </div>
      <div class="wizard-panel__column wizard-panel__column_main js-wizard-panel-column">
        <div v-if="activeWorkFunction">
          <header class="panel-head">
            <div class="panel-head__inner">
              <div class="panel-head__item">
                <h2 v-html="activeWorkFunction.name"></h2>

                <p class="panel-head__text">Компетенции были добавлены автоматически, на&nbsp;основе выбранной
                  квалификации. <br/> Вы&nbsp;можете добавлять, создавать и&nbsp;удалять компетенции.</p>
              </div>
            </div>
          </header>

          <Tabs :key="activeWorkFunction.id">
            <Tab title="Другие характеристики">

              <ul class="actions-list">
                <li style="text-align: center; color: #e2e2e2;" v-if="workFunctionItems.additionals.length === 0">
                  Нет трудовых действий для отображения
                </li>
                <li class="actions-list__item" v-for="additional in workFunctionItems.additionals">
                  <div class="action">
                    <span v-html="additional.name"></span>

                    <!--              <selector-btn v-if="!read" class="ml-16" :options="accordionActionOptionsForBtn" :params="{ id: action.id, item: action }"  @clickOnItem="callback"></selector-btn>-->
                  </div>
                </li>
              </ul>

            </Tab>

            <Tab title="Трудовые действия">
              <button type="button" v-if="!read" class="btn btn_action-second btn_full mb-24"
                      @click.prevent="elDialogs.workActions = true">
                Добавить трудовые действия
                <icon-base width="12" height="12" viewBox="0 0 12 12" class="btn__icon">
                  <icon-action/>
                </icon-base>
              </button>

              <ul class="actions-list">
                <li style="text-align: center; color: #e2e2e2;" v-if="workFunctionItems.actions.length === 0">
                  Нет трудовых действий для отображения
                </li>
                <li class="actions-list__item" v-for="action in workFunctionItems.actions">
                  <div class="action">
                    <span v-html="action.name"></span>

                    <selector-btn v-if="!read" class="ml-16" :options="accordionActionOptionsForBtn"
                                  :params="{ id: action.id, item: action }" @clickOnItem="callback"></selector-btn>
                  </div>
                </li>
              </ul>
            </Tab>

            <Tab title="Знания">
              <button type="button" class="btn btn_action-second btn_full mb-24" v-if="!read"
                      @click.prevent="elDialogs.workKnowledge = true">
                Добавить знания

                <icon-base width="12" height="12" viewBox="0 0 12 12" class="btn__icon">
                  <icon-action/>
                </icon-base>
              </button>

              <ul class="actions-list">
                <li style="text-align: center; color: #e2e2e2;" v-if="workFunctionItems.knowledge.length === 0">
                  Нет знаний для отображения
                </li>
                <li class="actions-list__item" v-for="knowledge in workFunctionItems.knowledge">
                  <div class="action">
                    <span v-html="knowledge.name"></span>

                    <selector-btn v-if="!read" class="ml-16" :options="accordionWorkKnowledgeOptionsForBtn"
                                  :params="{ id: knowledge.id, item: knowledge }"
                                  @clickOnItem="callback"></selector-btn>
                  </div>
                </li>
              </ul>
            </Tab>

            <Tab title="Умения">
              <button type="button" class="btn btn_action-second btn_full mb-24" v-if="!read"
                      @click.prevent="elDialogs.workSkills = true">
                Добавить умения
                <icon-base width="12" height="12" viewBox="0 0 12 12" class="btn__icon">
                  <icon-action/>
                </icon-base>
              </button>

              <ul class="actions-list">
                <li style="text-align: center; color: #e2e2e2;" v-if="workFunctionItems.skills.length === 0">
                  Нет умений для отображения
                </li>
                <li class="actions-list__item" v-for="skill in workFunctionItems.skills">
                  <div class="action">
                    <span v-html="skill.name"></span>

                    <selector-btn v-if="!read" class="ml-16" :options="accordionWorkSkillOptionsForBtn"
                                  :params="{ id: skill.id, item: skill }" @clickOnItem="callback"></selector-btn>
                  </div>
                </li>
              </ul>
            </Tab>
          </Tabs>
        </div>
      </div>
    </div>


    <!--                         :qualificationId="activeTraining.qualification_to ? activeTraining.qualification_to.id : 0"-->
    <!-- DIALOGS -->
    <programs-dialog
        v-if="this.showProgramsDialog"
        mode="qualification"
        :qualification-id="qualification.id"
        :trainingId="0"
        :qualificationFromId="qualification.id"
        :read="true"/>

    <programs-dialog-view v-if="elDialogs.viewQualificationPrograms"
                          :visible="elDialogs.viewQualificationPrograms"
                          @close="elDialogs.viewQualificationPrograms = false"
                          :programs="programsByQualification"/>
    <work-actions-dialog :workFunctionId="activeWorkFunction.id" v-if="activeWorkFunction"/>
    <work-functions-dialog v-if="qualification.id" :qualificationId="qualification.id"/>
    <work-knowledge-dialog :workFunctionId="activeWorkFunction.id" v-if="activeWorkFunction"/>
    <work-skills-dialog :workFunctionId="activeWorkFunction.id" v-if="activeWorkFunction"/>
    <!-- /DIALOGS -->
  </wizard-panel>
</template>

<script>
import Vue from 'vue';
import MaskedInput from 'vue-masked-input';
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';

import {groupBy} from '@/helpers';
import panel from '@/mixins/panel';
import constants from '@/constants.js';

import Accordion from '@/components/Accordion/Accordion';
import AccordionItem from '@/components/Accordion/AccordionItem';
import ProgramsDialog from '@/components/Dialogs/ProgramsDialog';
import Tab from '@/components/Tabs/Tab';
import Tabs from '@/components/Tabs/Tabs';
import WizardPanel from '@/components/WizardPanels/WizardPanel';
import WorkActionsDialog from '@/components/Dialogs/WorkActionsDialog';
import WorkFunctionsDialog from '@/components/Dialogs/WorkFunctionsDialog';
import WorkKnowledgeDialog from '@/components/Dialogs/WorkKnowledgeDialog';
import WorkSkillsDialog from '@/components/Dialogs/WorkSkillsDialog';
import Tree from '@/components/Tree/Tree';
import LocalPreloader from '@/components/LocalPreloader'
import ProgramsDialogView from "@/components/Dialogs/ProgramsDialogView";
import RepeatableTextField from "@/components/Forms/RepeatableTextField.vue";
import SaveBtn from "@/components/Buttons/SaveBtn.vue";
import EditBtn from "@/components/Buttons/EditBtn.vue";
import ValidateInput from "@/components/ValidateInput.vue";
import FormInfoHeader from "@/components/Panels/FormInfoHeader.vue";
import CancelBtn from "@/components/Buttons/CancelBtn.vue";
import CellInput from "@/components/CellInput.vue";

const initialData = () => {
  return {
    activeTraining: {},
    activeWorkFunction: null,
    mainInfoEditable: false,
    workFunctionsDescription: false,
    forceChangeOnFull: false,
    scale: 1,
    normalHeight: 0,
    relationsType: {
      related: 'Связанные',
      inherited: 'Родственные'
    },
    editableForms: {
      related_jobs: false,
      special_conditions: false,
      rights_to_work: false,
      ways_to_get_qualification: false,
      docs: false,
      validity: false,
    },
    showProgramsDialog: false,

    qualificationPrograms: [],
  }
}

export default {
  mixins: [panel],
  components: {
    CellInput, CancelBtn, FormInfoHeader, ValidateInput, EditBtn, SaveBtn, RepeatableTextField,
    ProgramsDialogView,
    Accordion,
    AccordionItem,
    MaskedInput,
    ProgramsDialog,
    Tab,
    Tabs,
    WizardPanel,
    WorkActionsDialog,
    WorkFunctionsDialog,
    WorkKnowledgeDialog,
    WorkSkillsDialog,
    Tree,
    LocalPreloader
  },
  props: {
    activeTraining: {
      type: Object,
      default: function () {
        return {};
      }
    },
    workFunctionsByQualificationLoader: {
      type: Boolean,
      default: false
    },
    programsByQualificationLoader: {
      type: Boolean,
      default: false
    },
    standartLoader: {
      type: Boolean,
      default: false
    },
    hardSkillsByQualificationLoader: {
      type: Boolean,
      default: false
    },
    softSkillsByQualificationLoader: {
      type: Boolean,
      default: false
    },
    interrelationsByQualificationLoader: {
      type: Boolean,
      default: false
    },
    style: {
      type: Object,
      default: {}
    },
    read: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return initialData();
  },
  methods: {
    ...mapActions('editor', ['CREATE_WORK_FUNCTION', 'LOAD_HARD_SKILLS_BY_QUALIFICATION', 'LOAD_INTERRELATIONS_BY_QUALIFICATION', 'LOAD_SOFT_SKILLS_BY_QUALIFICATION', 'LOAD_PROGRAMS_BY_QUALIFICATION', 'LOAD_WORK_FUNCTION_ITEMS', 'UPDATE_QUALIFICATION', 'LOAD_AREAS_NO_ORK']),
    ...mapMutations('common', ['SET_CURRENT_PARENT']),
    standardObj(standard_id) {
      if (standard_id === null) {
        return false;
      }
      return this.standard != null ? this.standard : this.GET_STANDARD_BY_ID(standard_id);
    },
    async switchToDiagram() {
      await this.LOAD_INTERRELATIONS_BY_QUALIFICATION(this.qualification.id);
    },
    closePanel() {
      Object.assign(this.$data, initialData());
    },
    async getWorkFunctionItems(item) {
      await this.LOAD_WORK_FUNCTION_ITEMS(item.id)

      this.activeWorkFunction = item;
    },
    async loadQualificationPrograms() {
      await this.LOAD_PROGRAMS_BY_QUALIFICATION(this.qualification.id);
      console.log('loading');
      this.elDialogs.viewQualificationPrograms = true;
    },
    async forceFullWidth(currentIndex) {

      await this.SET_CURRENT_PARENT(this.qualification.id)
      await this.LOAD_INTERRELATIONS_BY_QUALIFICATION(this.qualification.id);

      if (currentIndex === 1) {
        this.forceChangeOnFull = true
        this.elPanels.qualification = 2
      } else {
        this.forceChangeOnFull = false
        this.elPanels.qualification = 1
      }
    },
    onlyNumber(e) {
      if ((e.keyCode > 31 && (e.keyCode < 48 || e.keyCode > 57))) {
        e.preventDefault();
      } else {
        return true;
      }
    },
    async updateQualification(e, editable) {
      // Собираем новые значения и отправляем
      const formData = new FormData(e.target);

      const params = {};

      for (const pair of formData.entries()) {
        params[pair[0]] = pair[1];
      }

      await this.UPDATE_QUALIFICATION({
        ...this.qualification,
        ...params
      });

      this[editable] = false;
    },
    scaleUp() {
      this.scale = (this.scale * 10 + 1) / 10
    },
    scaleDown() {
      this.scale = (this.scale * 10 - 1) / 10
    },
  },
  computed: {
    ...mapGetters('editor', ['GET_AREA_BY_ID', 'GET_KIND_BY_ID', 'GET_STANDARD_BY_ID']),
    ...mapState('common', ['panels']),
    ...mapState('editor', ['areas']),
    ...mapState('editor', ['standard', 'interrelationsByQualification', 'programsByQualification', 'hardSkillsByQualification', 'qualification', 'softSkillsByQualification', 'workFunctionsByQualification', 'workFunctionItems', 'intersectionsPaths']),

    softSkills() {
      return JSON.parse(JSON.stringify(this.softSkillsByQualification));
    },

    groupInterrelations() {
      return groupBy('relation_type', this.interrelationsByQualification);
    },

    treeInterrelations() {
      const tree = {
        qualification_to: {
          code: this.qualification.code,
          name: this.qualification.name,
          trainings: this.interrelationsByQualification
        }
      }

      return tree;
    },

    area() {
      if (!this.qualification.area_id) {
        return false;
      }
      return this.GET_AREA_BY_ID(this.qualification.area_id);
    }
  },
  watch: {

      'qualification.name': function (val) {
        this.nameForQualification = val
      },
      'qualification.level': function (val) {
        this.levelForQualification = val
      },
      'qualification.sublevel': function (val) {
        this.sublevelForQualification = val
      },
      'qualification.docs': function (val) {
        if (Array.isArray(val) && val.every(item => typeof item === 'string')) {
          this.docsForQualification = [val]
        } else {
          this.docsForQualification = val
        }
      },
      'qualification.extra': function (val) {
        this.extraForQualification = val
      },
      'qualification.add_chars': function (val) {
        this.addCharsForQualification = val
      },
      'qualification.requirement': function (val) {
        this.requirementForQualification = val
      },
      'qualification.invalid_at': function (val) {
        this.invalid_at = val;
      },
      'qualification.validity': function (val) {
        this.validityForQualification = val
      },
      'qualification.ways_to_get_qualification': function (val) {
        if (val.length === 0) {
          this.waysToGetQualification = {formal_education: [''], self_education: [''], work_experience: ['']};
        } else {
          this.waysToGetQualification = val
        }
      },
      'qualification.related_jobs': function (val) {
        this.relatedJobs = val;
      },
      'qualification.special_conditions': function (val) {
        this.special_conditions = val;
      },
      'qualification.order_details': function (val) {
        this.order_details = Object.assign({}, val);
      },
      'qualification.protocol_details': function (val) {
        console.log(val);
        this.protocol_details = Object.assign({}, val);
      },
      'qualification.rights_to_work': function (val) {
        this.rights_to_work = val;
      },

    scale: function (val, oldVal) {
      const tree = this.$refs.tree.$el

      if (oldVal === 1) this.normalHeight = tree.scrollHeight
      tree.style.transform = `scale(${val})`
      tree.style.height = `${this.normalHeight * val}px`
    },
    forceChangeOnFull: function (val) {
      if (!val) {
        this.scale = 1
      }
    },
  },
  created() {
    this.SELECT_NOT_FOUND = constants.SELECT_NOT_FOUND;
    if (!this.areas || this.areas.length === 0) {
      this.LOAD_AREAS_NO_ORK();
    }
  },

}
</script>
